// export const node_url = 'http://172.20.10.2:5005' + "/";
// export const node_url = window.location.origin + "/";
// export const node_url = 'http://10.253.22.134:5005/'
// export const node_url = 'http://192.168.1.101:5005/'
export const node_url = 'https://bebamzigo.com/'
export const url = node_url + 'api/v1/';
